import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import socket from 'shared/lib/socket';

/**
 * Site Maintenance Store
 *
 * Keeps track of whether the site is undergoing maintenance
 *
 */
export default Reflux.createStore({
  listenables: [],

  mixins: [BaseMixin],

  init() {
    this._socket = socket.get();

    this._socket.on('siteMaintenance', (enabled) => {
      this.setStateAndTrigger(enabled);
    });
  },
});
